import { render, staticRenderFns } from "./TreeselectAccountOption.ts.vue?vue&type=template&id=af780f68"
import script from "./TreeselectAccountOption.ts.vue?vue&type=script&lang=ts&setup=true"
export * from "./TreeselectAccountOption.ts.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./TreeselectAccountOption.ts.vue?vue&type=style&index=0&id=af780f68&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports